export const ActionTypes = {
    ADD_SGC_CONFIGURATION_MODE: "ADD_SGC_CONFIGURATION_MODE",
    EDIT_SGC_CONFIGURATION_MODE: "EDIT_SGC_CONFIGURATION_MODE",
    DELETE_SGC_CONFIGURATION_MODE: "DELETE_SGC_CONFIGURATION_MODE",
    CLEAR_SGC_CONFIGURATIONS: "CLEAR_SGC_CONFIGURATIONS",
    OPEN_SGC_CONFIGURATION_SNACK: "OPEN_SGC_CONFIGURATION_SNACK",
    CLOSE_SGC_CONFIGURATION_SNACK: "CLOSE_SGC_CONFIGURATION_SNACK",
    GET_SGC_CONFIGURATIONS: "GET_SGC_CONFIGURATIONS",
    SET_SGC_CONFIGURATIONS_FILTERS: "SET_SGC_CONFIGURATIONS_FILTERS",
    SGC_CONFIGURATION_SELECTED: "SGC_CONFIGURATION_SELECTED",
    RESET_SGC_CONFIGURATION_SELECTED: "RESET_SGC_CONFIGURATION_SELECTED",
    CREATE_SGC_CONFIGURATION: "CREATE_SGC_CONFIGURATION",
    MOD_SGC_CONFIGURATION: "MOD_SGC_CONFIGURATION",
    DELETE_SGC_CONFIGURATION: "DELETE_SGC_CONFIGURATION",
    
    SET_CONFIG_PAGE_SGC_CONFIGURATIONS: "SET_CONFIG_PAGE_SGC_CONFIGURATIONS",
    SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS: "SET_CONFIG_PAGE_SIZE_SGC_CONFIGURATIONS",
    SET_CONFIG_FILTER_SGC_CONFIGURATIONS: "SET_CONFIG_FILTER_SGC_CONFIGURATIONS",
    SET_CONFIG_SORTED_SGC_CONFIGURATIONS: "SET_CONFIG_SORTED_SGC_CONFIGURATIONS",
};
